require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-algorithm-fundamentals-merge-sort.json") })
        }
      }, "path---blog-algorithm-fundamentals-merge-sort");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-algorithm-fundamentals-merge-sort!./.cache/json/blog-algorithm-fundamentals-merge-sort.json
// module id = 585
// module chunks = 231608221292675